// src/components/CybersecurityPosture.js
import React from 'react';
import { useTranslation } from 'react-i18next';
import { FaShieldAlt, FaSearch, FaTasks, FaLightbulb } from 'react-icons/fa';
import Footer from './footer';
import './cybersecurityPosture.css';

import SubpagesVector from '../assets/subpages-vector.svg';

function CybersecurityPosture() {
  const { t } = useTranslation();

  return (
    <div className="cybersecurity-posture-view">
      <div className="gradient-background"></div>

      <div className="cybersecurity-posture-content">
        {/* HERO WRAPPER */}
        <div className="posture-hero-wrapper">
          <div className="posture-hero-background"></div>

          <div className="posture-hero-container">
            <div className="posture-hero-content">
              <h1 className="posture-title">
                {t('posture')}
                <svg
                  className="shield-icon"
                  width="82"
                  height="109"
                  viewBox="0 0 82 109"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    className="shield-path"
                    d="M41 0L0 20.3344V68.1809C0 79.0068 4.31963 89.3893 12.0086 97.0443C19.6976 104.699 30.1261 109 41 109C51.8739 109 62.3024 104.699 69.9914 97.0443C77.6804 89.3893 82 79.0068 82 68.1809V20.3344L41 0ZM64.3358 92.9105L41 81.3369V88.916L58.2067 97.4499C53.0231 100.455 47.1362 102.049 41.1377 102.072C35.1393 102.095 29.2405 100.545 24.0341 97.5788C18.8278 94.6126 14.4974 90.3343 11.478 85.1739C8.45869 80.0136 6.85679 74.1529 6.83333 68.1809V24.5238L41 7.57841L75.1667 24.5238V37.2798L41 20.334V27.9125L75.1667 44.8578V57.6138L41 40.6684V48.2468L75.1667 65.1919V68.1809C75.1683 71.271 74.7429 74.3466 73.9025 77.3213L41 61.0025V68.5809L71.3919 83.6544C69.5891 87.1189 67.2024 90.2497 64.3358 92.9105Z"
                  />
                </svg>
              </h1>
              <h1 className="assessment-title">{t('assessment')}</h1>
              <p className="subtitle">{t('postureHeroSubtitle')}</p>
            </div>
          </div>
        </div>

        {/* CRITICAL PHASE SECTION */}
        <div className="critical-phase-section">
          <h2 className="critical-phase-subtitle">
            {t('criticalPhaseSubtitle')}
          </h2>

          <div className="critical-phase-grid">
            {/* Item 1 */}
            <div className="critical-phase-item">
              <div className="critical-phase-title">
                <FaShieldAlt className="critical-phase-icon" />
                <span>{t('advancedVulnerabilityScanning')}</span>
              </div>
              <div className="critical-phase-item-line"></div>
              <p>{t('advancedVulnerabilityScanningDesc')}</p>
            </div>

            {/* Item 2 */}
            <div className="critical-phase-item">
              <div className="critical-phase-title">
                <FaSearch className="critical-phase-icon" />
                <span>{t('strategicRiskPrioritization')}</span>
              </div>
              <div className="critical-phase-item-line"></div>
              <p>{t('strategicRiskPrioritizationDesc')}</p>
            </div>

            {/* Item 3 */}
            <div className="critical-phase-item">
              <div className="critical-phase-title">
                <FaTasks className="critical-phase-icon" />
                <span>{t('tailoredRecommendations')}</span>
              </div>
              <div className="critical-phase-item-line"></div>
              <p>{t('tailoredRecommendationsDesc')}</p>
            </div>

            {/* Item 4 */}
            <div className="critical-phase-item">
              <div className="critical-phase-title">
                <FaLightbulb className="critical-phase-icon" />
                <span>{t('attackSurfaceMapping')}</span>
              </div>
              <div className="critical-phase-item-line"></div>
              <p>{t('attackSurfaceMappingDesc')}</p>
            </div>
          </div>
        </div>

        {/* POST-CRITICAL PHASE SECTION */}
        <div className="post-critical-phase-section">
          <img
            src={SubpagesVector}
            alt="Subpages Vector"
            className="post-critical-phase-image"
          />
          <p className="post-critical-phase-text">
            {t('postCriticalPhaseText')}
          </p>
        </div>
      </div>

      <Footer />
    </div>
  );
}

export default CybersecurityPosture;
